<template>
  <div
    v-if="loaded"
    class="page"
  >
    <div class="page__sidebar">
      <archive-side-bar
        :counters="sidebarSummary"
        @update-option="onUpdateCustomFilter($event)"
        @click-add-filter="onAddCustomFilter($event)"
      />
    </div>
    <div class="page__main">
      <router-view
        ref="mainContent"
        class="page__main-content"
        @reload-sidebar-summary="loadSidebarSummary()"
      />
    </div>
  </div>
</template>

<script>
import ArchiveSideBar from './sideBar/ArchiveSideBar'
import sideBarStore from './sideBar/archiveSideBarStore'
import archiveFilterService from '@/modules/archiveModule/services/archiveFilterService'

export default {
    name: 'ArchiveIndex',
    components: {
        ArchiveSideBar
    },
    data() {
        return {
            loaded: true,
            sideBarState: sideBarStore.state,
            sidebarSummaryInterval: null,
            sidebarSummary: null,
            predefinedFiltersSummary: null
        }
    },
    computed: {
        routeName() {
            return this.$route.name
        },
        labId() {
            return this.$store.getters.labId
        }
    },
    async created() {
        try {
            if (this.sideBarState.config.defaultOptionId) {
                sideBarStore.selectDefaultOption()
            }

            await Promise.all([
                archiveFilterService.loadSamplePendingUnarchivingReasons(),
                archiveFilterService.loadPortionPendingUnarchivingReasons(),
                archiveFilterService.loadSubportionPendingUnarchivingReasons(),
                this.loadSidebarSummary()
            ])

            this.sidebarSummaryInterval = this.$_setSummaryInterval(this.loadSidebarSummary)
        } finally {
            this.loaded = true
        }
    },
    beforeDestroy() {
        if (this.sidebarSummaryInterval !== null) {
            clearInterval(this.sidebarSummaryInterval)
        }
        this.cleanSearchStateGlobalMixin()
    },
    methods: {
        async loadSidebarSummary() {
            this.sidebarSummary = await archiveFilterService.getSummary(this.labId)
        },
        async onUpdateCustomFilter(option) {
            if (this.$refs.mainContent.onUpdateCustomFilter) {
                await this.$refs.mainContent.onUpdateCustomFilter(option)
            }
        },
        async onAddCustomFilter() {
            if (this.$refs.mainContent.onAddCustomFilter) {
                await this.$refs.mainContent.onAddCustomFilter()
            }
        }
    }
}
</script>
